import styled from "styled-components";
import animate from "../../../utils/animations";

export const Wrapper = styled.div`
  z-index: 1;
  background-color: #fff;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
`;

interface IIconProps {
  success?: boolean;
  error?: boolean;
}

export const Icon = styled.div`
  margin: 10px 0;
  font-size: 2.5em;
  color: ${(props: IIconProps) => props.success && "#27ae60"};
  color: ${(props: IIconProps) => props.error && "#79D9D9"};
  ${animate("bounceIn", 0.75, 0.15)};
`;

export const Text = styled.div`
  text-align: center;
  font-size: 1.2em;
  font-weight: 400;
  margin: 10px 0 20px 0;
  ${animate("fadeInUp", 0.3, 0.25)};
`;
